import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';
import { screensService } from 'shared/src/api';

export const useGoodsDetailAtomics = (enabled?: boolean) => {
  const sno = useGoodsSno();
  return useQuery({
    enabled,
    queryKey: queryKey.goodsAtomicComponents(sno),
    queryFn: () =>
      screensService.get({
        screen: 'GOODS_DETAIL',
        goods_sno: sno,
        next_token: null,
      }),
  });
};
